import { useState, useLayoutEffect, useRef } from 'react';

// Единый словарь расшифровок статусов для всей админки.
// Использование: <StatusInfo def="referral" />  рядом с заголовком/значением статуса.
export const STATUS_DEFS = {
  referral: {
    title: 'Статусы направления',
    items: [
      ['Направлен', 'Врач добавил пациента и привязал к цели. Ждём ближайшей ночной проверки (опрос идёт по расписанию, не мгновенно).'],
      ['Подтверждён', 'Проверка прошла, оплат до даты привязки не было — направление действующее, ждём первой оплаты (до 30 дней).'],
      ['Дубль', 'У пациента была оплата этой цели ДО даты привязки — он уже был её клиентом, комиссия по нему не начисляется.'],
      ['Дошёл', 'Была первая оплата — далее по пациенту считаются повторные визиты.'],
      ['Не дошёл', 'Пациент не оплатил ни разу за 30 дней с момента привязки — направление снято, слот и связка пациент-цель освобождены для другого врача.'],
      ['Неактивно', 'Направление неактивно (например, откреплено).'],
    ],
  },
  operation_invoice: {
    title: 'Счёт клинике по операции',
    items: [
      ['Ожидает оплаты', 'Счёт создан автоматически при закрытии окна направления — клиника/сеть ещё не перевела Refero комиссию врачу + нашу долю.'],
      ['Оплачено', 'Клиника/сеть перевела Refero деньги по этому счёту — можно выплачивать врачу (кнопка «Выплатить»).'],
      ['Важно', 'Клиника в своём ЛК видит счёт («Выставлен») только после того, как счёт СКАЧАН здесь, в админке (та же логика, что у обычных счетов N-055) — статус в её кабинете может отставать от реального, если счёт ещё не открывали.'],
    ],
  },
  operation_conditions: {
    title: 'Условия «Операций»',
    items: [
      ['Что это', 'Параллельная система направлений — врач направляет пациента на конкретную операцию/процедуру, комиссия считается один раз как % от суммы ВСЕХ его оплат за установленный период. Не связано с обычными первичными/повторными визитами и квотой.'],
      ['0% или не задано', 'Цель не появится у врачей в списке «Добавить на операцию» — специального флага включения программы нет, всё регулируется через процент.'],
      ['Изменение условий', 'Первая настройка — сразу; изменение — с 00:01 1 числа следующего месяца; нельзя понижать % или сокращать период (та же логика, что у обычных условий).'],
    ],
  },
  api: {
    title: 'Статус API цели',
    items: [
      ['Не проверено', 'Подключение к API ещё не тестировалось.'],
      ['Активно', 'Последняя проверка API цели прошла успешно — опрос работает.'],
      ['Ошибка', 'Последняя проверка/опрос API не прошли.'],
    ],
  },
  payment: {
    title: 'Статус выплаты комиссии',
    items: [
      ['Ожидает', 'Выплата врачу ещё не отправлена.'],
      ['Выплачено', 'Деньги переведены врачу банковским переводом, но чек (СМЗ) ещё не принят или акт (ИП) ещё не подтверждён врачом — промежуточный этап.'],
      ['Принято', 'Чек принят Refero (СМЗ) или акт принят врачом (ИП) — выплата полностью закрыта.'],
    ],
  },
  clinic_active: {
    title: 'Статус подключения клиники',
    items: [
      ['Активна', 'Клиника подключена к Refero и видна врачам как цель для направления.'],
      ['Скрыто', 'Клиника/сеть подключена и работает (API, опрос), но временно не показывается врачам как цель — кнопка «Скрыть/Показать» на странице цели. Новые клиники/сети создаются скрытыми по умолчанию: пока проверяете API и заводите договор в реестре, врачи её не видят и не могут привязать пациента.'],
      ['Отключена', 'Договор расторгнут / клиника отключена (действуют обязательства, если срок не истёк) — необратимо в отличие от «Скрыто».'],
    ],
  },
  doctor_active: {
    title: 'Статус аккаунта врача',
    items: [
      ['Активен', 'Врач может входить в кабинет и направлять пациентов.'],
      ['Отключён', 'Аккаунт деактивирован — вход в кабинет заблокирован.'],
      ['Заблокирован (анти-фрод)', 'Автоматическая блокировка при достижении лимита счётчика недошедших направлений (200) — добавление пациентов недоступно, остальной кабинет открыт.'],
      ['Кабинет заблокирован', 'Ручная блокировка администратором — весь кабинет недоступен, врач видит причину блокировки.'],
    ],
  },
  doctor_active_base: {
    title: 'Активная база направлений',
    items: [
      ['Что считаем', 'Количество НАПРАВЛЕНИЙ врача в статусе «Направлен»/«Подтверждён» (ещё не дошёл, не дубль, не сгорел). Один пациент в 2 клиниках = 2 направления = +2 к базе, а не +1.'],
      ['Освобождение слота', 'Место освобождается сразу, как только направление доходит до исхода: пациент дошёл (оплатил), признан дублем или сгорел по истечении срока цели.'],
      ['Лимит', 'При достижении лимита (100) добавление НОВЫХ пациентов недоступно, пока часть направлений не разрешится. Это мотивационный троттлинг, не анти-фрод блокировка — сбрасывается само, админ ничего не резетит.'],
    ],
  },
  doctor_non_arrived: {
    title: 'База недошедших направлений',
    items: [
      ['Что считаем', 'Счётчик НАПРАВЛЕНИЙ, сгоревших по истечении срока цели (статус «Не дошёл»). +1 за каждое сгоревшее направление, не за уникального пациента — растёт только от сгораний, никогда не уменьшается сам.'],
      ['Отличие от активной базы', 'Не зависит от конверсий — это анти-фрод механизм, а не мотивационный троттлинг.'],
      ['Лимит', 'При достижении лимита (200) кабинет врача блокируется автоматически (запрет на добавление пациентов) — разблокировать может только техподдержка/админ, сбросив счётчик.'],
    ],
  },
  doctor_daily_add: {
    title: 'Добавлено пациентов сегодня',
    items: [
      ['Что считаем', 'Количество УНИКАЛЬНЫХ пациентов, впервые добавленных врачом сегодня (по московскому времени). Направление того же пациента ещё в одну клинику в тот же день не считается новым добавлением.'],
      ['Лимит', 'При достижении лимита (10) добавление новых пациентов доступно только на следующий день.'],
    ],
  },
  doctor_verification: {
    title: 'Верификация врача (выписка ЕГИСЗ)',
    items: [
      ['Новый', 'Врач ещё не загрузил выписку ЕГИСЗ об аккредитации — добавление пациентов недоступно.'],
      ['На проверке', 'Документ загружен, ждёт решения администратора.'],
      ['Верифицирован', 'Проверка пройдена — добавление пациентов доступно.'],
      ['Отклонён', 'Администратор отклонил документ (с причиной) — врач должен загрузить его повторно.'],
    ],
  },
  clinic_invoice: {
    title: 'Статус оплаты клиникой Refero',
    items: [
      ['Не оплачено', 'Счёт клинике/сети за этот месяц ещё не выставлен.'],
      ['Ожидает оплаты', 'Счёт выставлен, ждём оплаты от клиники/сети.'],
      ['Оплачено', 'Клиника/сеть оплатила — по этой цели можно выплачивать врачам.'],
    ],
  },
  commissions_doctors_total: {
    title: 'Комиссий врачей за месяц',
    items: [
      ['Что считаем', 'Вся сумма комиссий врачам (первичные + повторные) за выбранный месяц, по ВСЕМ врачам и статусам выплаты — и уже выплаченным, и ещё ожидающим. Это общий объём заработка врачей за месяц, а не то, что осталось выплатить.'],
      ['Отличие от «К выплате врачам»', '«К выплате врачам» — только неоплаченная часть (по врачам, у которых есть хоть одна невыплаченная комиссия). Эта карточка — сумма целиком, независимо от статуса.'],
    ],
  },
  commissions_clinics_to_pay: {
    title: 'Сумма к выплате от клиник',
    items: [
      ['Что считаем', 'Общая сумма (комиссии врачам + наш %) по всем клиникам/сетям за выбранный месяц — сколько мы в итоге ждём от клиник, независимо от того, выставлен ли уже счёт и оплачен ли он.'],
    ],
  },
  commissions_clinics_debt: {
    title: 'Клиники должны Refero',
    items: [
      ['Что считаем', 'Часть суммы выше, которая ещё НЕ оплачена — статус счёта «Не оплачено» или «Ожидает оплаты». Уже оплаченные счета сюда не входят — это текущий реальный долг клиник перед Refero на сейчас.'],
    ],
  },
  period_reconciliation: {
    title: 'Сверка данных за месяц',
    items: [
      ['Не подтверждён', 'Данные клиники за месяц ещё не сверены полностью (сбой опроса API или сверка ещё не запускалась) — выставить счёт нельзя.'],
      ['Сверка идёт…', 'Сверка запущена и выполняется в фоне (может занимать несколько минут для нестабильного API клиники) — обновится сама, ничего нажимать не нужно.'],
      ['Подтверждён', 'Опрос дошёл до конца месяца по всем направлениям цели — сумма счёта окончательная.'],
    ],
  },
  clinic_invoice_actions: {
    title: 'Действия со счётом клиники',
    items: [
      ['—', 'Месяц ещё не завершился — по нему рано что-либо делать, действия появятся после его окончания.'],
      ['Повторить сверку', 'Показывается для завершённого месяца, пока он не подтверждён. Донагоняет опрос API клиники по всем дням месяца и проверяет полноту данных — запускается в фоне, без этого счёт выставить нельзя.'],
      ['Сформировать счёт', 'Появляется, когда месяц подтверждён сверкой. Замораживает текущую сумму (комиссии врачам + наш %) и создаёт счёт с номером.'],
      ['Скачать счёт', 'Доступно после выставления счёта — скачивает PDF с реквизитами клиники и суммой к оплате.'],
      ['Оплачено', 'Отмечает счёт оплаченным (с подтверждением по названию клиники/сети). После этого разблокируется выплата врачам, у которых эта цель была последней неоплаченной.'],
    ],
  },
  duplicate_first_payment: {
    title: 'Дата $ заявлено',
    items: [
      ['Что это', 'Дата первой оплаты пациента, которую назвала клиника при выставлении статуса «Дубль» — фиксируется автоматически при ночном опросе.'],
      ['Зачем', 'Единственная улика при разборе спора в ТП, если врач считает «Дубль» ложным (например, пациент утверждает, что впервые оплатил уже после даты привязки — значит, дата от клиники может быть недостоверной).'],
      ['Прочерк', 'У направлений в других статусах поле не заполняется — оно имеет смысл только для «Дубля».'],
    ],
  },
  doctor_payout_actions: {
    title: 'Действия по выплате врачу',
    items: [
      ['—', 'Месяц ещё не завершился — по нему рано что-либо делать, действия появятся после его окончания.'],
      ['Выплатить (красная)', 'У врача не заполнены реквизиты выплат — нельзя выплатить, пока он их не укажет в профиле.'],
      ['Выплатить (серая)', 'Реквизиты заполнены, но ещё не все клиники/сети этого врача оплатили Refero за месяц.'],
      ['Выплатить (активная)', 'И реквизиты заполнены, и все клиники/сети оплатили — можно выплачивать.'],
      ['Открыть чек', 'Появляется после «Выплатить» у самозанятого врача. Активна, когда врач загрузил чек — открывает его для принятия/отклонения. Серая — врач ещё не загрузил или чек отклонён.'],
      ['Загрузить акт / Акт отправлен / Акт принят', 'Появляется после «Выплатить» у врача-ИП. Админ загружает акт-справку, врач его принимает в своём кабинете — до этого можно перезалить исправленную версию.'],
    ],
  },
  dash_doctors: {
    title: 'Карточка «Врачей»',
    items: [
      ['Что считаем', 'Все аккаунты врачей, когда-либо зарегистрированных через форму регистрации ЛК (email+пароль+ФИО). Регистрация доступна любому — без модерации на входе.'],
      ['Учитываются ВСЕ статусы', 'Считаются все врачи независимо от верификации ЕГИСЗ (новый/на проверке/верифицирован/отклонён) и от активности аккаунта (активен/отключён/заблокирован анти-фродом/кабинет заблокирован админом) — это просто счётчик учётных записей в системе, не «рабочих» врачей.'],
      ['Прирост за период', 'Считается по дате регистрации внутри выбранного диапазона дат — срезовая метрика (текущее состояние + дельта), не накопительная.'],
    ],
  },
  dash_patients: {
    title: 'Карточка «Пациентов»',
    items: [
      ['Что считаем', 'Уникальные пациенты в базе. Запись создаётся, когда врач впервые добавляет пациента (ФИО + дата рождения) и привязывает к цели.'],
      ['Матчинг', 'Матчинг по ФИО + дате рождения (без строгой идентификации). Если такой пациент уже есть в базе — новая запись НЕ создаётся, просто добавляется ещё одно направление к новой цели тем же или другим врачом.'],
      ['Прирост за период', 'По дате первого появления пациента в системе — срезовая метрика.'],
    ],
  },
  dash_patients_reached: {
    title: 'Карточка «Пациентов дошли»',
    items: [
      ['Что считаем', 'Уникальные пациенты, у которых есть хотя бы одна оплаченная транзакция хотя бы по одному направлению (т.е. реально пришли в клинику и оплатили визит) — статус направления «Дошёл» хотя бы по одной цели.'],
      ['Уникальность', 'Считается по пациенту, не по направлениям — если один пациент дошёл сразу в 2 клиники, он всё равно один в этой карточке.'],
      ['Прирост за период', 'По дате первой оплаты (первого визита) — срезовая метрика.'],
    ],
  },
  dash_clinics: {
    title: 'Карточка «Клиник»',
    items: [
      ['Что считаем', 'Все физические учреждения со статусом «Активна» — и отдельные клиники, и клиники-члены сетей (сами сети как отдельные строки не учитываются, это счётчик учреждений, а не целей направления). Показывает, сколько физически есть учреждений, куда могут быть направлены пациенты.'],
      ['Прирост за период', 'По дате подключения клиники к Refero — срезовая метрика.'],
    ],
  },
  dash_referrals: {
    title: 'Карточка «Направлений»',
    items: [
      ['Что считаем', 'Количество направлений — одна запись = один пациент привязан ОДНИМ врачом к ОДНОЙ цели (клинике или сети). Один пациент у двух врачей или в двух клиниках — это 2 разных направления.'],
      ['Все статусы', 'Считаются направления в любом статусе (Направлен/Подтверждён/Дошёл/Дубль/Не дошёл) — это просто факт привязки, не индикатор успеха.'],
      ['За период', 'По дате привязки — накопительная дневная метрика, точная по дням (не «полными месяцами», как денежные показатели).'],
    ],
  },
  dash_transactions: {
    title: 'Карточка «Транзакций»',
    items: [
      ['Что считаем', 'Одна запись = одна СУММАРНАЯ оплата пациентом за один календарный день по одному направлению (агрегат по дню, не по отдельным услугам/чекам внутри дня).'],
      ['За период', 'По дате оплаты — накопительная дневная метрика, точная по дням.'],
    ],
  },
  dash_commissions: {
    title: 'Карточка «Комиссии врачей»',
    items: [
      ['Что считаем', 'Сумма, начисленная врачам с оплат пациентов клиникам: первичные визиты — всегда; повторные визиты — только если врач выполнил месячную квоту по этой конкретной цели.'],
      ['Источник', 'Считается напрямую по транзакциям, не по помесячной агрегированной таблице — поэтому точна по датам оплаты, а не «размазана» по календарным месяцам.'],
      ['Не включает', 'НЕ включает нашу комиссию (10% от комиссии врача, см. карточку «Доход Refero») — это то, что причитается целиком врачам.'],
    ],
  },
  dash_platform_fee: {
    title: 'Карточка «Доход Refero»',
    items: [
      ['Что считаем', 'Наша комиссия — 10% от суммы, начисленной врачу по каждой оплате. Начисляется по тем же правилам, что и комиссия врача: с первичных — всегда, с повторных — только после выполнения врачом квоты по этой цели.'],
      ['Отдельно от комиссий врачей', 'Не входит в сумму карточки «Комиссии врачей» выше — это независимая, наша часть денег.'],
      ['За период', 'По дате оплаты.'],
    ],
  },
  dash_referred_all: {
    title: 'Карточка «Оплачено клиникам всего»',
    items: [
      ['Что считаем', 'Валовая сумма ВСЕХ оплат пациентов клиникам по направлениям через Refero — первичные и повторные визиты вместе, ДО вычета любых комиссий (ни врачу, ни Refero).'],
      ['Смысл метрики', 'Показывает, сколько денег клиники фактически получили благодаря направлениям врачей через платформу — то есть создаваемую Refero ценность для клиники.'],
      ['Состав', 'Равна сумме двух карточек ниже («первичные» + «повторные»).'],
    ],
  },
  dash_referred_primary: {
    title: 'Карточка «Оплачено — первичные визиты»',
    items: [
      ['Что считаем', 'Часть суммы «Оплачено клиникам всего» — только оплаты ПЕРВЫХ визитов пациентов, то есть момент, когда пациент впервые пришёл в клинику по направлению врача.'],
      ['Валовая сумма', 'Это вся сумма чека клиники за первичный визит, не комиссия — комиссия с неё считается отдельно и начисляется всегда, независимо от квоты.'],
    ],
  },
  dash_referred_repeat: {
    title: 'Карточка «Оплачено — повторные визиты»',
    items: [
      ['Что считаем', 'Часть суммы «Оплачено клиникам всего» — оплаты ПОВТОРНЫХ визитов того же пациента в той же клинике/сети, уже после первого визита.'],
      ['Квота здесь ни при чём', 'Это валовая сумма, которую заплатил пациент клинике — она попадает сюда независимо от того, выполнил ли врач квоту. Квота влияет только на то, получит ли врач С ЭТОЙ суммы комиссию (см. карточку «Комиссии врачей»).'],
    ],
  },
  poll_run: {
    title: 'Опрос клиник за день',
    items: [
      ['Что это', 'Итог ежедневного опроса API клиник/сетей (daily_poll) за КОНКРЕТНЫЙ календарный день — проверка пациентов на дубль, поиск новых оплат, закрытие таймеров/операций.'],
      ['Обновление', 'Один и тот же день может переопрашиваться повторно следующими ночами (скользящее окно catch-up) — строка обновляется, а не дублируется, поэтому картина всегда актуальная, включая случаи, когда ошибки дня исчезли после повторной попытки.'],
      ['Ошибки', 'Количество целей, у которых в этот день не удалось получить полный ответ хотя бы от одного источника API — эти направления просто переопрашиваются позже, ничего не теряется.'],
    ],
  },
  poll_target_status: {
    title: 'Текущий статус API цели',
    items: [
      ['Активно', 'Последний опрос этой цели прошёл без ошибок.'],
      ['Ошибка', '3 неудачных опроса подряд — опрос продолжается (самовосстановление при первом же успехе), но пока цель считается недоступной.'],
      ['Не проверено', 'Подключение к API этой цели ещё ни разу не тестировалось.'],
      ['Счётчик ошибок', 'Сколько раз подряд не удалось опросить — обнуляется первым же успешным опросом.'],
    ],
  },
};

const TIP_WIDTH = 320;

export default function StatusInfo({ def, text }) {
  const [pos, setPos] = useState(null);
  const [rect, setRect] = useState(null); // rect иконки — нужен для пересчёта top после замера реальной высоты
  const tipRef = useRef(null);
  // text — облегчённый режим для тултипов в заголовках колонок таблиц: одна короткая
  // фраза без заголовка/жирного лейбла (в отличие от def — расшифровки статусов из словаря).
  const d = text ? { title: null, items: [[null, text]] } : (typeof def === 'string' ? STATUS_DEFS[def] : def);

  // Тултип позиционируем fixed по координатам иконки и клампим по горизонтали сразу
  // (ширина фиксирована — TIP_WIDTH); по вертикали высота заранее неизвестна (зависит
  // от кол-ва пунктов), поэтому открываем вниз, а после рендера (useLayoutEffect ниже)
  // замеряем реальную высоту и переключаем вверх от иконки, если снизу не помещается.
  const open = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    let left = r.left + r.width / 2 - TIP_WIDTH / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - TIP_WIDTH - 8));
    setRect(r);
    setPos({ left, top: r.bottom + 8 });
  };

  useLayoutEffect(() => {
    if (!pos || !rect || !tipRef.current) return;
    const h = tipRef.current.offsetHeight;
    if (rect.bottom + 8 + h > window.innerHeight - 8) {
      const top = Math.max(8, rect.top - h - 8);
      if (top !== pos.top) setPos((p) => ({ ...p, top }));
    }
  }, [pos, rect]);

  if (!d) return null;

  return (
    <span
      style={s.wrap}
      onMouseEnter={open}
      onMouseLeave={() => setPos(null)}
    >
      <span style={s.icon}>i</span>
      {pos && (
        <span ref={tipRef} style={{ ...s.tip, left: pos.left, top: pos.top }}>
          {d.title && <span style={s.tipTitle}>{d.title}</span>}
          {d.items.map(([label, desc], i) => (
            <span key={label || i} style={s.tipRow}>
              {label && <b style={s.tipLabel}>{label}</b>}
              <span style={s.tipDesc}>{desc}</span>
            </span>
          ))}
        </span>
      )}
    </span>
  );
}

const s = {
  wrap: { position: 'relative', display: 'inline-flex', verticalAlign: 'middle', marginLeft: 6 },
  icon: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 14, height: 14, borderRadius: '50%', border: '1.2px solid #64748b',
    color: '#94a3b8', fontSize: 9, fontFamily: 'Georgia, serif', fontStyle: 'italic', fontWeight: 700,
    textTransform: 'none', cursor: 'help', userSelect: 'none', lineHeight: 1, flexShrink: 0,
  },
  tip: {
    position: 'fixed', zIndex: 1000, width: TIP_WIDTH, boxSizing: 'border-box',
    background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: '12px 14px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)', textAlign: 'left', textTransform: 'none',
    display: 'flex', flexDirection: 'column', gap: 8, whiteSpace: 'normal', cursor: 'default',
    letterSpacing: 0,
  },
  tipTitle: { color: '#e2e8f0', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4 },
  tipRow: { display: 'flex', flexDirection: 'column', gap: 2 },
  tipLabel: { color: '#2EC4B6', fontSize: 13, fontWeight: 600 },
  tipDesc: { color: '#94a3b8', fontSize: 12, lineHeight: 1.4, fontWeight: 400 },
};
